import { render, staticRenderFns } from "./plan_bzr.vue?vue&type=template&id=540777e1"
import script from "./plan_bzr.vue?vue&type=script&lang=js"
export * from "./plan_bzr.vue?vue&type=script&lang=js"
import style0 from "./plan_bzr.vue?vue&type=style&index=0&id=540777e1&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports